import { CdkPortalOutlet, PortalModule, PortalOutlet } from '@angular/cdk/portal';
import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { FlyoutService, NavigationService } from '@app/core/services';
import { FeedbackPanelComponent } from '../../components/feedback-panel/feedback-panel.component';
import { HeaderComponent } from '../header/header.component';
import { MenuComponent } from '../menu/menu.component';

@Component({
    selector: 'app-design',
    templateUrl: './design.component.html',
    styleUrls: ['./design.component.less'],
    standalone: true,
    imports: [
        HeaderComponent,
        MatSidenavModule,
        MenuComponent,
        FeedbackPanelComponent,
        PortalModule,
    ],
})
export class DesignComponent implements AfterViewInit {
	/**
	 * When true, hides the header and menu/flyout drawers, but still renders the projected route content
	 */
	@Input() minimal = false;

	@ViewChild('flyout') flyout: MatDrawer;
	@ViewChild(CdkPortalOutlet, { static: false }) portalOutlet: PortalOutlet;

	menuIsOpened = false;
	constructor(private readonly navigationService: NavigationService, private readonly flyoutService: FlyoutService) {}

	ngAfterViewInit(): void {
		this.navigationService.sideNavOpened$.subscribe((value) => (this.menuIsOpened = value));
		this.flyoutService.open$.subscribe((opened) => {
			if (this.flyout) {
				this.flyout.toggle(opened);
			}

			if (!opened) {
				if (this.portalOutlet.hasAttached()) {
					this.portalOutlet.detach();
				}
			}
		});
		this.flyoutService.flyout$.subscribe((flyout) => {
			if (this.portalOutlet.hasAttached()) {
				this.portalOutlet.detach();
			}
			this.portalOutlet.attach(flyout);
		});
	}
}
